import { createMutex } from 'locks';

const mutex = createMutex();

export function acquire() {
  return new Promise(resolve => mutex.lock(resolve));
}

export function unlock() {
  return mutex.unlock();
}
